import { render, staticRenderFns } from "./TheInformation.vue?vue&type=template&id=741b96dc&scoped=true"
import script from "./TheInformation.vue?vue&type=script&lang=ts"
export * from "./TheInformation.vue?vue&type=script&lang=ts"
import style0 from "./TheInformation.vue?vue&type=style&index=0&id=741b96dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741b96dc",
  null
  
)

export default component.exports